const passkey_sign_in = {
    setup_page: {
        title: "Semplifica l'accesso",
        subtitle: 'Crea una passkey',
        description: 'Registra la tua passkey usando i dati biometrici del dispositivo, chiavi di sicurezza come YubiKey o altri metodi disponibili.',
    },
    trigger_conditional_ui_failed: "Impossibile attivare l'autocompilazione con passkey.",
};
export default Object.freeze(passkey_sign_in);
